export var DeviceType;
(function (DeviceType) {
    DeviceType["IOS"] = "ios";
    DeviceType["ANDROID"] = "android";
    DeviceType["WEB"] = "web";
})(DeviceType || (DeviceType = {}));
